import FoodPreferences from "../features/food/food-preferences/food-preferences"
import { SearchFoodByX } from "../features/food/search-food-by-x/search-food-by-x";

const Foodpreferencessearch = () => {
    return <SearchFoodByX />

}

export default Foodpreferencessearch;